const API_URL = process.env.REACT_APP_API_URL || 'https://api.playkokki.com/';
export const BASE_URL = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;

const TOKEN_KEY = 'kokki-jwt-token';
export const AUTH_EXPIRED_EVENT = 'kokki-auth-expired';

export const getAuthToken = (): string | null => localStorage.getItem(TOKEN_KEY);

export const setAuthToken = (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const clearAuthToken = (): void => {
    localStorage.removeItem(TOKEN_KEY);
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
    }
};

export const getAuthHeaders = (): HeadersInit => {
    const token = getAuthToken();
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

export const getAuthHeadersNoContent = (): HeadersInit => {
    const token = getAuthToken();
    const headers: HeadersInit = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

export const readApiError = async (
    response: Response,
    fallback: string,
    expireSession = true,
): Promise<Error> => {
    const data = await response.json().catch(() => ({}));
    const message = Array.isArray(data.message) ? data.message.join(', ') : data.message;

    if (response.status === 401 || (expireSession && response.status === 403)) {
        clearAuthToken();
        return new Error(message || 'Your admin session expired. Please log in again.');
    }

    return new Error(message || fallback);
};

export const loginAdmin = async (password: string): Promise<{ access_token: string }> => {
    const response = await fetch(`${BASE_URL}auth/admin-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
    });

    if (!response.ok) {
        throw await readApiError(response, 'Invalid password', false);
    }

    return response.json();
};

export const validateAdminSession = async (): Promise<void> => {
    const response = await fetch(`${BASE_URL}auth/admin-session`, {
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw await readApiError(response, 'Admin session is no longer valid');
    }
};
